<!-- 地址选择组件 -->
<template>
  <div v-loading="loading" element-loading-background="rgba(255, 255,255, 0.1)">
    <el-form :model='form' class='demo-ruleForm' :rules='rules' ref='form' label-position='top' :disabled="disabled">
      <el-row :gutter='20' class='address'>
        <el-col :span='5'>
          <el-form-item prop='province'>
            <el-select v-model='form.province' placeholder='请选择省'>
              <el-option v-for='item in provinces' :key='item.name' :value='item.name'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='5'>
          <el-form-item prop='city'>
            <el-select v-model='form.city' placeholder='请选择市'>
              <el-option v-for='item in citys' :key='item.name' :value='item.name'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span='6'>
          <el-form-item prop='district'>
            <el-select v-model='form.district' placeholder='请选择区/县'>
              <el-option v-for='item in districts' :key='item.name' :value='item.name'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 18px;margin-left: 1px" :gutter="20">
        <el-col :span='16'>
          <el-form-item prop='detail'>
            <el-input placeholder='请填写详细地址' type="textarea"
                      :rows="2" v-model='form.detail'>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

</template>
<script>
import {gaode_address_data} from "./utils/addressData";

const STABLE_HOST = 'https://oneapi.coderbox.cn/openapi/public/chinaregion'
const BACKUP_HOST = 'https://dmfw.mca.gov.cn/9095/xzqh/getList'
const GAODE_HOST = "http://delivery.biozeron.com/static_resource/api/get/gaode_district"

export default {
  name: 'WAddress',
  props: {
    address: {type: String, default: ''},
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {
      rules: {
        province: [{required: true, message: '请选择省份', trigger: 'change'}],
        city: [{required: true, message: '请选择城市', trigger: 'change'}],
        district: [{required: true, message: '请选择区/县', trigger: 'change'}],
        detail: [{required: true, message: '请填写详细地址', trigger: 'blur'}]
      },
      form: {province: '', city: '', district: '', detail: ''},
      provinces: [],
      citys: [],
      districts: [],
      isEchoing: false, // 正在回显，屏蔽级联 watch
      allDress: [],
      isUseGaode: false,
      loading: true,
      API_WAY: ''
    }
  },
  watch: {
    address: {handler: 'echoAddress', immediate: true},
    async 'form.province'(val) {
      if (this.isEchoing) return
      let code = 'code'
      if (this.API_WAY === 'GAODE_HOST') {
        code = 'adcode'
      }
      await this.loadLevel('citys', this.getCode(val, this.provinces, code), this.getCode(val, this.citys, code, true)?.type === "直辖市")
      this.form.city = ''
      this.form.district = ''
    },
    async 'form.city'(val) {
      if (this.isEchoing) return
      let code = 'code'
      if (this.API_WAY === 'GAODE_HOST') {
        code = 'citycode'
      }
      if(val){
        await this.loadLevel('districts', this.getCode(val, this.citys, code))
      }else {
        this.districts=[]
      }
      this.form.district = ''
    },
    'form.district'() {
      if (this.isEchoing) return
      this.form.detail = ''
    }
  },
  methods: {
    fetchWithTimeout(timeout = 2000) {
      return async (url, options = {}) => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), timeout); // 到点就中断
        return await fetch(url, {...options, signal: controller.signal})
            .finally(() => clearTimeout(timer)); // 别忘了清定时器
      }
    },
    async loadLevel(target, pcode = '', isMunicipalities = false) {

      const ok = res => {
        return res.status === 200 ? res.json() : Promise.reject(res.status);
      }

      /* 1. STABLE_HOST */
      const tryStable = async () =>
          await this.fetchWithTimeout(2000)(pcode ? `${STABLE_HOST}?pcode=${pcode}` : STABLE_HOST)
              .then(ok)
              .then(res => {
                this.API_WAY = 'STABLE_HOST';
                const data = (res?.data || []);
                return target === 'districts'
                    ? data.concat({code: '', name: '其他区', level: 3, type: ''})
                    : data;
              })

      /* 2. BACKUP_HOST */
      const tryBackup = async () => {
        if (isMunicipalities) {
          return [{code: pcode, name: '市辖区', level: 2, type: '', children: []}];
        } else {
          return await this.fetchWithTimeout(2000)(pcode ? `${BACKUP_HOST}?code=${pcode}&maxLevel=1` : BACKUP_HOST)
              .then(ok)
              .then(res => {
                this.API_WAY = 'BACKUP_HOST';
                const data = (res?.data?.children || []);
                return target === 'districts'
                    ? data.concat({code: '', name: '其他区', level: 3, type: ''})
                    : data;
              })
        }
      }
      /* 3. GAODE_HOST */
      const tryGaode = async () => {
        this.API_WAY = 'GAODE_HOST';
        if (!this.allDress?.length) {

          this.allDress = gaode_address_data.districts[0].districts
        }
        if (pcode) {
          if (target === 'citys') {
            return this.allDress
                .find(item => item.adcode === pcode)?.districts
                .map(item => ({...item, name: item.name.includes('城区') ? '市辖区' : item.name})) || [];
          }
          return (this.citys.find(item => item.citycode === pcode)?.districts || [])
              .concat({citycode: '', adcode: '', name: '其他区', districts: []});
        }
        return this.allDress;
      };


      /* 链式：前一个失败才试下一个；任意成功则停 */
      let finalList = []
      if (!this.API_WAY) {
        finalList = await tryStable()
            .catch(async () => await tryBackup())
            .catch(async () => await tryGaode())
            .catch(() => []);   // 三个全挂就给空数组
      } else {
        switch (this.API_WAY) {
          case 'STABLE_HOST':
            finalList = await tryStable();
            break;
          case 'BACKUP_HOST':
            finalList = await tryBackup();
            break;
          case 'GAODE_HOST':
            finalList = await tryGaode();
            break;
        }
      }
      this[target] = finalList;
      this.loading = false;
    },
    getAddressProvince() {
      return this.loadLevel('provinces')
    },
    getCode(name, list, code = 'code', isAllInfo = false) {
      if (isAllInfo) {
        return (list.find(i => i.name === name) || {})
      } else {
        return (list.find(i => i.name === name) || {})[code]
      }

    },
    async echoAddress(address) {
      if (address) {
        this.loading = true;
        this.isEchoing = true
        await this.getAddressProvince()
        /* 省 */
        const pItem = this.provinces.find(i => address.includes(i.name))
        if (pItem) {
          this.form.province = pItem.name
          let code = 'code'
          if (this.API_WAY === 'GAODE_HOST') {
            code = 'adcode'
          }
          await this.loadLevel('citys', pItem[code], pItem?.type === "直辖市")
        }
        /* 市 */
        const cItem = this.citys.find(i => address.includes(i.name))
        if (cItem) {
          this.form.city = cItem.name
          let code = 'code'
          if (this.API_WAY === 'GAODE_HOST') {
            code = 'citycode'
          }
          await this.loadLevel('districts', cItem[code])
        }
        /* 区 */
        const dItem = this.districts.find(i => address.includes(i.name))
        if (dItem) {
          this.form.district = dItem.name
        }
        this.form.detail = address.split(this.form.province + this.form.city + this.form.district)[1]
        this.$nextTick(() => (this.isEchoing = false))
      } else {
        await this.getAddressProvince()
      }
    },
    getData() {
      return this.form
    }
  }
}
</script>
<style>
.address .el-form-item {
  margin-bottom: 0 !important;
  margin-right: 0 !important;
}
</style>
